import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EReportType } from '../../constans/report';
import DeleteConfirmationModal from '../../HOC/DeleteConfirmationModal/DeleteConfirmationModal';

export interface IDeleteReportMemberModal {
  active: boolean;
  type: EReportType;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DeleteReportMemberModal: FC<IDeleteReportMemberModal> = ({
  active,
  type,
  onClose,
  onConfirm
}) => {
  const { t } = useTranslation();

  const titles = {
    team: t('viewSurvey.reportsSetup.modals.delete.member.team.title'),
    executive: t('viewSurvey.reportsSetup.modals.delete.member.executive.title')
  };

  const texts = {
    team: t('viewSurvey.reportsSetup.modals.delete.member.team.text'),
    executive: t('viewSurvey.reportsSetup.modals.delete.member.executive.text')
  };

  return (
    <DeleteConfirmationModal
      active={active}
      actionLabel={t('viewSurvey.reportsSetup.modals.delete.actions.confirm')}
      cancelLabel={t('viewSurvey.reportsSetup.modals.delete.actions.cancel')}
      title={titles[type]}
      text={texts[type]}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default DeleteReportMemberModal;
